import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { API_URL } from "../pages/utils/utils";
import Swal from "sweetalert2";

export default function Footer() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleLoginChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    console.log("Login form submitted", loginData);
    
    // Validate form data
    if (!loginData.email || !loginData.password) {
      Swal.fire({
        icon: "warning",
        title: "Missing Information",
        text: "Please enter both email and password",
      });
      return;
    }

    setLoading(true);

    try {
      console.log("Sending login request to:", `${API_URL}login/passenger`);
      
      const response = await fetch(`${API_URL}login/passenger`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: loginData.email,
          password: loginData.password,
        }),
      });

      console.log("Response status:", response.status);
      const data = await response.json();
      console.log("Response data:", data);

      if (response.ok && data.data) {
        // Store user data
        login(data.data);
        
        // Close modal using Bootstrap 5
        const modalElement = document.getElementById("exampleModal");
        if (modalElement) {
          // Try Bootstrap 5 modal API
          if (window.bootstrap && window.bootstrap.Modal) {
            const modal = window.bootstrap.Modal.getInstance(modalElement);
            if (modal) {
              modal.hide();
            } else {
              // If no instance exists, create one and hide it
              const newModal = new window.bootstrap.Modal(modalElement);
              newModal.hide();
            }
          } else {
            // Fallback: manually hide the modal
            modalElement.classList.remove("show");
            modalElement.setAttribute("aria-hidden", "true");
            modalElement.style.display = "none";
            document.body.classList.remove("modal-open");
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
              backdrop.remove();
            }
            // Remove modal-open padding
            document.body.style.paddingRight = "";
          }
        }

        // Reset form
        setLoginData({ email: "", password: "" });

        // Show success message
        Swal.fire({
          icon: "success",
          title: "Login Successful",
          text: `Welcome back, ${data.data.first_name}!`,
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          // Redirect to dashboard
          navigate("/dashboard");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: data.message || data.error || "Invalid email or password",
        });
      }
    } catch (error) {
      console.error("Login error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred during login. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <footer
        className="pt-20 pb-4"
        style={{ backgroundImage: "url(images/background_pattern.png)" }}
      >
        <div
          className="section-shape top-0"
          style={{ backgroundImage: "url(images/shape8.png)" }}
        />
        <div className="footer-upper pb-4">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12 mb-4 pe-4">
                <div className="footer-about">
                  <img src="/images/white_logo.png" alt="" width={200} />
                  <p className="mt-3 mb-3 white">
                    Aircabi is a smart airport cab booking platform designed for travelers who value comfort, reliability, and peace of mind. Whether you’re landing late at night, flying out early morning, or traveling for business or leisure, Aircabi ensures a smooth door-to-door airport transfer—every time.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                <div className="footer-links">
                  <h3 className="white">Quick link</h3>
                  <ul>
                    <li>
                      <Link to="/about">About Us</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
                <div className="footer-links">
                  <h3 className="white">Contact</h3>
                  <ul>
                    <li className="white">
                      <strong>PO Box:</strong> +44 20 1234 5678
                    </li>
                    <li className="white">
                      <strong>Location:</strong> 254 Goldhawk Road, London, England, W12 9PE
                    </li>
                    <li className="white">
                      <strong>Email:</strong> info@aircabi.co.uk
                    </li>
                    <li className="white">
                      <strong>Website:</strong> aircabi.co.uk
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-payment">
          <div className="container">
            <div className="row footer-pay align-items-center justify-content-between text-lg-start text-center">
              <div className="col-lg-8 footer-payment-nav mb-4">
                <ul className="">
                  <li className="me-2">We Support:</li>
                  <li className="me-2">
                    <i className="fab fa-cc-mastercard fs-4" />
                  </li>
                  <li className="me-2">
                    <i className="fab fa-cc-paypal fs-4" />
                  </li>
                  <li className="me-2">
                    <i className="fab fa-cc-stripe fs-4" />
                  </li>
                  <li className="me-2">
                    <i className="fab fa-cc-visa fs-4" />
                  </li>
                  <li className="me-2">
                    <i className="fab fa-cc-discover fs-4" />
                  </li>
                </ul>
              </div>
              <div className="col-lg-4 footer-payment-nav mb-4">
              </div>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <div className="container">
            <div className="copyright-inner rounded p-3 d-md-flex align-items-center justify-content-between">
              <div className="copyright-text">
                <p className="m-0 white">2026 Aircabi. All rights reserved.</p>
              </div>
              <div className="social-links">
                <ul>
                  <li>
                    <a href="#">
                      <i className="fab fa-facebook" aria-hidden="true" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-twitter" aria-hidden="true" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-instagram" aria-hidden="true" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-linkedin" aria-hidden="true" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Back to top start */}
      <div id="back-to-top">
        <a href="#" />
      </div>
      {/* Back to top ends */}
      {/* search popup */}
      <div id="search1">
        <button type="button" className="close">
          ×
        </button>
        <form>
          <input
            type="search"
            defaultValue=""
            placeholder="type keyword(s) here"
          />
          <button type="submit" className="btn btn-primary">
            Search
          </button>
        </form>
      </div>
      {/* login registration modal */}
      <div
        className="modal fade log-reg"
        id="exampleModal"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="post-tabs">
                {/* tab contents */}
                <div className="tab-content blog-full" id="postsTabContent">
                  {/* popular posts */}
                  <div
                    aria-labelledby="login-tab"
                    className="tab-pane fade active show"
                    id="login"
                    role="tabpanel"
                  >
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="blog-image rounded">
                          <a
                            href="#"
                            style={{
                              backgroundImage:
                                "url(images/trending/trending5.jpg)",
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <h4 className="text-center border-b pb-2">Login</h4>
                        <form
                          method="post"
                          onSubmit={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleLoginSubmit(e);
                          }}
                          name="loginform"
                          id="loginform"
                          noValidate
                        >
                          <div className="form-group mb-2">
                            <input
                              type="email"
                              name="email"
                              className="form-control"
                              id="fname"
                              placeholder="Email Address"
                              value={loginData.email}
                              onChange={handleLoginChange}
                              required
                            />
                          </div>
                          <div className="form-group mb-2">
                            <input
                              type="password"
                              name="password"
                              className="form-control"
                              id="lpass"
                              placeholder="Password"
                              value={loginData.password}
                              onChange={handleLoginChange}
                              required
                            />
                          </div>
                          <div className="form-group mb-2">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="exampleCheck"
                            />
                            <label
                              className="custom-control-label mb-0"
                              htmlFor="exampleCheck1"
                            >
                              Remember me
                            </label>
                            <a
                              className="float-end"
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                // Close modal first
                                const modalElement = document.getElementById("exampleModal");
                                if (modalElement) {
                                  if (window.bootstrap && window.bootstrap.Modal) {
                                    const modal = window.bootstrap.Modal.getInstance(modalElement);
                                    if (modal) {
                                      modal.hide();
                                    }
                                  } else {
                                    modalElement.classList.remove("show");
                                    modalElement.style.display = "none";
                                    document.body.classList.remove("modal-open");
                                    const backdrop = document.querySelector(".modal-backdrop");
                                    if (backdrop) {
                                      backdrop.remove();
                                    }
                                  }
                                }
                                // Navigate to forgot password page
                                navigate("/forgot-password");
                              }}
                            >
                              Lost your password?
                            </a>
                          </div>
                          <div className="comment-btn mb-2 pb-2 text-center border-b">
                            <button
                              type="button"
                              className="nir-btn w-100"
                              id="login-submit-btn"
                              disabled={loading}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.log("Login button clicked");
                                
                                // Validate form
                                const form = document.getElementById('loginform');
                                if (form) {
                                  if (form.checkValidity()) {
                                    handleLoginSubmit(e);
                                  } else {
                                    form.reportValidity();
                                  }
                                } else {
                                  // Fallback: call handler directly
                                  handleLoginSubmit(e);
                                }
                              }}
                            >
                              {loading ? "Logging in..." : "Login"}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
